export class CustomError extends Error {
  code: string;
  body: unknown;

  constructor(code: string, body: unknown, message?: string) {
    super(message);
    this.code = code;
    this.body = body;

    Object.setPrototypeOf(this, CustomError.prototype);
  }
}
